import React, { Component } from 'react'
import { Segment, Header } from 'semantic-ui-react'

class Error401 extends Component {
  render() {
    return (
      <Segment basic>
        <Header as="h1">401 Error</Header>
      </Segment>
    )
  }
}

export default Error401
